// src/utils/imperativeFormIV_salim.js
// בניין 4 (أَفْعِلْ) - צורות הציווי לגזרת השלמים

const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';
const HARAKAT_RE = /[\u064B-\u065F\u0670]/g;
const NON_ARABIC_LETTERS_RE = /[^\u0621-\u064A]/g;

const stripHarakat = (value) => (value || '').replace(HARAKAT_RE, '');

function extractRootLetters(root) {
  const cleanRoot = stripHarakat(String(root || '').trim()).replace(NON_ARABIC_LETTERS_RE, '');
  if (cleanRoot.length !== 3) return null;
  return [cleanRoot[0], cleanRoot[1], cleanRoot[2]];
}

export function buildImperativeFormIV_Salim(root) {
  const radicals = extractRootLetters(root);
  if (!radicals) return null;

  const [R1, R2, R3] = radicals;
  const isNunEnding = R3 === 'ن';
  const stem = 'أ' + FATHA + R1 + SUKUN + R2 + KASRA + R3;

  return {
    you_ms: stem + SUKUN,
    you_fs: stem + KASRA + 'ي',
    you_mp: stem + DAMMA + 'وا',
    you_fp: isNunEnding ? stem + SHADDA + FATHA : stem + SUKUN + 'نَ',
  };
}

export function buildImperativeFromRowIV(row) {
  const binyan = String(row?.['בניין'] || row?.binyan || '').trim();
  const gizra = String(row?.['gizra'] || row?.gzira || row?.['גזרה'] || '').trim();

  if (!(binyan === '4' || binyan === 'בניין 4')) return null;
  if (!gizra.includes('שלמים')) return null;

  return buildImperativeFormIV_Salim(row?.['שורש'] || row?.root || '');
}
